import { sections, singleRow } from "./layoutTypings";
import type { RibbonControlInternalUnionProps } from "../../Controls/RibbonControlProps";

export function getDefaultLayout(
  controlProps: RibbonControlInternalUnionProps[]
) {
  return sections(singleRow(...controlProps.map((c) => c.id)));
}

export const sectionSpacerWidth = 4;
